// Component that traps focus within itself.
import { useKeyboardShortcut } from 'platform-specific/keyboardShortcutHandler';
import React, { useEffect, useRef } from 'react';
import type { View } from 'react-native';
import { Pressable, StyleSheet } from 'react-native';

const TAB_KEYCODE = 9;
const ESCAPE_KEYCODE = 27;

export type FocusLoopViewProps = { children: React.ReactNode; onCloseLoop: any; index: number };

export function FocusLoopView({ children, onCloseLoop, index }: FocusLoopViewProps) {
    useKeyboardShortcut({ shortcutKey: ESCAPE_KEYCODE, callback: onCloseLoop, index });
    const firstFocusableEl = useRef<View>(null);
    const lastFocusableEl = useRef<View>(null);
    let el: Element | null = null;

    function tabNavigationHandler(e) {
        if (e.keyCode === TAB_KEYCODE) {
            if (e.shiftKey && document.activeElement === firstFocusableEl.current) {
                e.preventDefault();
                lastFocusableEl.current?.focus();
            } else if (!e.shiftKey && document.activeElement === lastFocusableEl.current) {
                e.preventDefault();
                firstFocusableEl.current?.focus();
            }
        }
    }
    useKeyboardShortcut({ shortcutKey: TAB_KEYCODE, callback: tabNavigationHandler });

    useEffect(() => {
        el = document.activeElement;
        firstFocusableEl.current?.focus();
        return () => {
            (el as HTMLElement)?.focus();
        };
    }, []);

    const s = HiddenButtonStyle;
    return (
        <>
            <Pressable id='begin-focus-trap' ref={firstFocusableEl} role='button' style={s.hiddenButton} />
            {children}
            <Pressable
                id='end-focus-trap'
                onPress={onCloseLoop}
                ref={lastFocusableEl}
                role='button'
                style={s.hiddenButton}
                testID='end-focus-trap'
            />
        </>
    );
}

const HiddenButtonStyle = StyleSheet.create({
    hiddenButton: {
        opacity: 0,
        height: 0,
        width: 0,
    },
});
